/*
 * Email-confirmation selectors over the `signUp` store slice.
 *
 * Only the two below survive the retirement of in-app sign-up. The selectors
 * that read `signUpSuccessful`, `email` and `verificationResent` are gone with
 * the reducer fields they read — nothing outside this directory ever consumed
 * them, and the state they pointed at can no longer be written.
 *
 * ConfirmEmailPage is the sole consumer of both.
 */

import { createSelector } from 'reselect';

const selectEmailConfirmationDomain = () => (state) => state.signUp;

const selectVerificationResultPending = () =>
  createSelector(
    selectEmailConfirmationDomain(),
    (substate) => substate.verificationResultPending
  );

const selectEmailConfirmed = () =>
  createSelector(
    selectEmailConfirmationDomain(),
    (substate) => substate.emailConfirmed
  );

export { selectVerificationResultPending, selectEmailConfirmed };
